import { VS } from '../Components.js';
import PointType from '../PointType.js';
import Spell from '../Spell.js';

import AreaOfEffects from '../../Actions/AreaOfEffects.js';
import Durations from '../../Actions/Durations.js';
import Effects from '../../Actions/Effects.js';
import Ranges from '../../Actions/Ranges.js';
import Times from '../../Actions/Times.js';
import ToHits from '../../Actions/ToHits.js';
import Utilities from '../../Actions/Utilities.js';

export default new Spell(
  'Mage Hand',
  0,
  PointType.SpellSlot,
  [
    'A spectral, floating hand appears at a point you choose within range. The hand lasts for the duration or until you dismiss it as an action. The hand vanishes if it is ever more than 30 feet away from you or if you cast this spell again.',
    'You can use your action to control the hand. You can use the hand to manipulate an object, open an unlocked door or container, stow or retrieve an item from an open container, or pour the contents out of a vial. You can move the hand up to 30 feet each time you use it.',
    "The hand can't attack, activate magic items, or carry more than 10 pounds.",
  ],
  Utilities.NonCombat,
  Times.Action,
  Durations.Minutes(1),
  Ranges.Range(30),
  AreaOfEffects.SingleTarget,
  ToHits.AlwaysWorks,
  Effects.Utility(),
  VS,
  'Conjuration'
);
